import { render, staticRenderFns } from "./NewProgram.vue?vue&type=template&id=8fd57fa0"
import script from "./NewProgram.vue?vue&type=script&lang=ts"
export * from "./NewProgram.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports